import { ExpansionContextProvider } from 'utils/contexts/expansion';
import { AudienceCount } from 'modules/segmentation/types';
import { Table } from './Table';
import { AudienceCountsTableSkeleton } from './AudienceCountsTableSkeleton';
import { EmptyData } from '../insightEmptyData';

type AudienceCountsProps = {
  values: AudienceCount[];
  hasChart?: boolean;
  isLoading?: boolean;
};

export const AudienceCountsTable = ({
  values,
  isLoading = false,
  hasChart = false,
}: AudienceCountsProps) => {
  if (isLoading) return <AudienceCountsTableSkeleton />;

  return values.length > 0 ? (
    <ExpansionContextProvider>
      <Table values={values} hasChart={hasChart} />
    </ExpansionContextProvider>
  ) : (
    <EmptyData />
  );
};
